// extracted by mini-css-extract-plugin
module.exports = {"title-modal":"_398dXKGFKv7sbFR1sGkMbX","dialog":"_16QXf6r0LFqwcgilhb91QY","body-text":"s2Z3IcuNTmk8JQsOownok"};